import { createStyles, makeStyles } from '@material-ui/core/styles';
import {
  useEffect,
  //  useRef,
  useState,
} from 'react';
import { Grid } from '@material-ui/core';
// import LanguageSelector from '../../LanguageSelector';
import Layout from '../Layout';
import LoginForm from '../Form/Implementations/LoginForm';
import NauLogo from '../NauLogo';
import PageTemplate from '../PageTemplate';
import SocialNetworks from './SocialNetworks';
import commonStyleRules from '../styles';
// import { languages } from '../../../constants/languages';
import { requestLogin } from '../../../redux/actions/authActions';
import styleRules from './styles';
import { useAppSelector } from '../../../hooks/hooks';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { validateEmail } from '../Form/Validation';

const useStyles = makeStyles((theme) => createStyles({ ...commonStyleRules(theme), ...styleRules(theme) }));

const Login = (): JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { header, left, link } = useStyles();
  // const [language, setLanguage] = useState(languages[0]);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [formatError, setFormatError] = useState('');
  // const anchorRef = useRef<HTMLButtonElement>(null);
  const navigation = useHistory();
  const loginError = useAppSelector((state) => state.auth.errorText);
  const loading = useAppSelector((state) => state.auth.loading);

  const isEmailValid = validateEmail(email);
  const isFormFilled = email && password;
  const isFormEmpty = !email && !password;

  useEffect(() => {
    if (email && !isEmailValid) setFormatError(t('profile.email.error'));
    if (isEmailValid || isFormEmpty) setFormatError('');
  }, [email, password, isEmailValid, t, isFormEmpty]);

  const handleSubmit = () => {
    if (hasError) {
      return;
    }
    dispatch(requestLogin({ email, password }));
  };

  const hasError = !isFormFilled || Boolean(formatError);

  return (
    <Layout>
      <Grid container item direction="column" md={5} wrap="nowrap" className={left}>
        <Grid className={header} container item justifyContent="space-between" wrap="nowrap">
          <NauLogo />
          <Grid container justifyContent="flex-end">
            {/* <LanguageSelector
              anchorRef={anchorRef}
              languages={languages}
              currentLanguage={language}
              setLanguage={setLanguage}
            /> */}
          </Grid>
        </Grid>
        <PageTemplate
          title={t('auth.welcome.title')}
          description={t('auth.welcome.subtitle')}
          form={
            <LoginForm
              email={email}
              password={password}
              setEmail={setEmail}
              setPassword={setPassword}
              isEmailValid={!Boolean(formatError)}
              onSubmit={handleSubmit}
              error={formatError || t(loginError)}
            />
          }
          hint={
            <>
              {t('auth.dont.have.acc')}{' '}
              <a
                className={link}
                href="/registration"
                onClick={(e) => {
                  e.preventDefault();
                  navigation.push('/registration');
                }}
              >
                {t('auth.register.now')}
              </a>{' '}
            </>
          }
          socialNetworks={<SocialNetworks />}
          submit={handleSubmit}
          submitButtonContent={t('auth.log.in')}
          isLoading={loading}
          disableSubmit={hasError}
        />
      </Grid>
    </Layout>
  );
};

export default Login;
